import * as Actions from '../actions';

const initialState = {
	role: [], // guest
	data: {
		displayName: 'Demo user',
		photoURL: '',
		email: 'demo@example.com'
	}
};

const user = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_USER_DATA: {
			return {
				...state,
				...action.payload
			};
		}
		case Actions.UPDATE_USER_DATA: {
			const newData = { ...state, data: { ...action.payload } };
			return {
				...state,
				...newData
			};
		}
		case Actions.REMOVE_USER_DATA: {
			return {
				...initialState
			};
		}
		case Actions.USER_LOGGED_OUT: {
			return initialState;
		}
		default: {
			return state;
		}
	}
};

export default user;
